<template>
  <div class="page">
    <van-nav-bar title="实习考勤" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <attendance-empty v-if="detail.signList.length == 0"></attendance-empty>
    <van-tabs v-else type="line" v-model="active" animated color="#0088F8" @change="tabsChange">
      <van-tab title="实习考勤">
        <!-- 顶部盒子 -->
        <div class="top-card">
          <div class="title">{{ detail.title }} ></div>
          <div class="tip">起止时间: {{ detail.jhkssj }}～{{ detail.jhjssj }}</div>
          <div class="time-box" v-if="kqdkFlag">
            <div v-for="(item, index) in detail.signList" :key="'sign' + index" :style="{ width: showSignBox(index) ? '95%' : '0', marginRight: index % 2 != 0 ? '0px' : '10px' }">
              <div class="item" v-if="showSignBox(index)">
                <div class="time">{{ item.taskTitle }} {{ item.signTime }}</div>
                <div class="status">
                  <img src="../../../../assets/images/sign_icon2.png" alt="" v-if="showIconNormal(item.dklxmc)" />
                  <img src="../../../../assets/images/sign_icon1.png" alt="" v-if="showIconLate(item.dklxmc)" />
                  {{ item.dksj }} {{ item.dklxmc }}
                </div>
              </div>
            </div>
          </div>
           <div v-else class="sxoverdiv">
               <p>
                {{detail.isCanDk==-1?'实习已结束！':'实习未开始！'}}
               </p>
           </div>
        </div>
        <!-- 地图打卡盒子 -->
        <div class="option-card" v-if="kqdkFlag">
          <div class="address-box">
            <div class="title">
              <div class="address">{{ address }}</div>
            </div>
            <div class="map">
              <el-amap class="amap-box" :vid="'amap-vue'" :amap-manager="amapManager" :plugin="plugin"></el-amap>
            </div>
          </div>
          <div class="sign-box">
            <div class="item" @click="sign" :style="{ backgroundImage: getBackGround }">
              <div class="name">{{ signName }}</div>
              <div class="now">{{ time }}</div>
            </div>
            <div class="status">
              <img src="../../../../assets/images/icon_choose.png" alt="" v-if="iconType == 1" />
              <img src="../../../../assets/images/icon_none_choose.png" v-else alt="" />
              <div>{{ signText }}</div>
            </div>
          </div>
        </div>
      </van-tab>
      <!-- 日历 -->
      <van-tab title="打卡日历">
        <div class="total-box">
          <div class="title" style="margin-bottom: 10px;">
            <van-field v-model="dkny" is-link readonly label="打卡年月" input-align="right" error-message-align="right" placeholder="请选择" @click="showDatePicker"  />
          </div>
          <div class="title" @click="routeLinkTotal()">
            <div class="left">{{ dkny }}汇总</div>
            <!-- <img src="../../static/right-arrow.png" /> -->
            <van-icon name="arrow" />
          </div>
          <div class="content">
            <div class="item-box" v-for="(item, index) in pageData.totalList" :key="'total' + index">
              <div class="top">{{ item.value }}</div>
              <div class="bottom">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="calendar">
          <div class="title">
            每日记录
            <p>({{dkny}})</p>
          </div>
          <Calendar @onDayClick="dateClick" ref="ren" :headerBar="false" :mark-days="pageData.dayList" :year-and-month-to-see="dqdkyf" :kqdk-flag="kqdkFlag" :open="true" :disabledAfter="true"></Calendar>
          <!-- 当日打卡记录 -->
          <div class="details" v-for="(item, index) in attendanceList" :key="index">
            <div class="left-box">
              <div class="circle"></div>
              <div class="line" v-if="index != attendanceList.length - 1"></div>
            </div>
            <div class="right-box" >
              <div class="right-title">
                <div class="text">{{ item.name }}{{ item.time }}</div>
                <div class="status" :style="{ background: showIconLate(item.name) ? '#FE923F' : '#0189F9' }">{{ item.name }}</div>
              </div>
              <div class="centent">
                <p v-if="item.address != ''">签到地点: {{ item.address }}</p>
                <p v-if="item.remarks != ''">备注: {{ item.remarks }}</p>
              </div>
              <div v-if="item.name == '缺卡'" class="apply-button" @click="$router.push({ path: '/internship/replacement', query: { id: item.kqjlid, date: clickDate,bkd:index,dklx:item.dklx } })">补卡申请</div>
              <img v-if="item.fileBase64 != ''" class="sign-img" :src="item.fileBase64" alt="" />
            </div>
          </div>
          <div v-if="attendanceList.length == 0" class="empty-sign">
            <img src="../../../../assets/images/no_sign.png" alt="" />
            <div>暂无打卡记录</div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <!-- 打卡弹窗 -->
    <van-popup v-model="showDialog" round position="bottom" style="padding-bottom: 20px" :style="{ minHeight: '310px' }">
      <div class="popup">
        <div class="header">
          <img src="../../../../assets/images/icon_close.png" alt="" @click="closeSignPopup" />
          <div class="title">{{ signName }}</div>
        </div>
        <div class="upload" v-if="detail.qdsbxpz == 1">
          <div>拍照（必填）</div>
          <!-- 不允许选用本地照片 -->
          <van-uploader accept="image/*" :max-size="5 * 1024 * 1024" @oversize="$toast('文件大小不能超过 5M ')" v-model="fileList" v-if="detail.byxscbdzp == 1" capture="camera" prediv-size="50px" :after-read="upload" max-count="1">
            <div class="add"><img src="../../../../assets/images/take_picture.png" alt="" /></div>
          </van-uploader>
          <!-- 允许选用本地照片 -->
          <van-uploader accept="image/*" :max-size="5 * 1024 * 1024" @oversize="$toast('文件大小不能超过 5M ')" v-model="fileList" v-else prediv-size="50px" :after-read="upload" max-count="1">
            <div class="add"><img src="../../../../assets/images/take_picture.png" alt="" /></div>
          </van-uploader>
        </div>
        <div class="remark">
          <div>备注（选填）</div>
          <van-field v-model="form.dkbz" rows="1" autosize label="" type="textarea" maxlength="200" placeholder="请输入留言" show-word-limit />
        </div>
        <div style="height: 50px"></div>
        <div class="sure-button" @click="saveSignData">{{ time }} {{ signName }}</div>
      </div>
    </van-popup>
    <StatePop ref="state" :type="stateType"></StatePop>

     <!-- 打卡年月-->
     <van-popup v-model="showPickerDate" position="bottom">
      <van-picker title="选择打卡年月" show-toolbar  :default-index="dkbyIndex" @cancel="showPickerDate = false" :columns="dknyList" @confirm="chooseDate" />
    </van-popup>
  </div>
</template>

<script>
import iApi from '@/utils/internship'
import AttendanceEmpty from './components/attendanceEmpty'
import { mapGetters } from 'vuex'
import Calendar from './components/calendar'
import StatePop from './components/statePop'
import { AMapManager } from 'vue-amap'
let amapManager = new AMapManager()
export default {
  components: {
    AttendanceEmpty,
    Calendar,
    StatePop,
  },
  data() {
    let self = this
    return {
      signName: '无法打卡',
      dkny:'',
      dkbyIndex:0,
      kqdkFlag:true,
      showPickerDate:false,
      yerToSee:'',
      monthToSee:'',
      dknyList:[],
      dqdkyf:'',
      signText: '',
      iconType: 0,
      signType: '01',
      stateType: 0,
      backGround: 'linear-gradient(180deg, #0092FF 0%, #026CFE 100%)',
      pageData: {},
      amapManager,
      showDialog: false,
      signStatus: {
        isdk: false,
        iswq: false,
      },
      inTime: false,
      fileList: [],
      markDays: [],
      lng: '112.88337', // 经度
      lat: '28.20818', // 纬度
      plugin: [
        {
          pName: 'Geolocation',
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：5s
          buttonPosition: 'RB', //定位按钮的停靠位置
          zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
          //   showMarker: false, //定位成功后在定位到的位置显示点标记，默认：true
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                console.log(status)
                console.log(result)
                console.log(self.complete)
                if (status == 'complete') {
                  self.complete(result)
                } else {
                  self.$toast.fail('定位失败！')
                }
              })
            },
          },
        },
      ],
      address: '定位中',
      detail: {
        title: '', // 实习计划名称
        jhkssj: '', // 计划开始时间
        jhjssj: '', // 计划结束时间
        signList: [],
      },
      form: {
        sxjhid: '',
        sxgwid: '',
        dkdd: '',
        dkbz: '',
        sqzp: '',
        dklx: '',
        lng: '',
        lat: '',
        kqjlid: '',
        type: '',
      },
      remark: '',
      timer: null,
      time: '',
      active: 0,
      clickDate: new Date().format('yyyy-MM-dd'),
      totalList: [
        {
          name: '平均工时',
          value: '7.9',
        },
        {
          name: '迟到次数',
          value: '0',
        },
        {
          name: '早退次数',
          value: '0',
        },
      ],
      attendanceList: [],
    }
  },
  computed: {
    getStatusText() {
      return status => {}
    },
    ...mapGetters({
      sxjhid: 'getSxjhid',
    }),
    showSignBox() {
      return index => {
        if (this.detail.qdcs == '1') {
          if (index == 0) {
            return true
          } else {
            return false
          }
        } else if (this.detail.qdcs == '2') {
          if (index == 0 || index == 1) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      }
    },
    getBackGround() {
      if (this.signName == '上班打卡' || this.signName == '下班打卡' || this.signName == '更新打卡') {
        return 'linear-gradient(180deg, #0092FF 0%, #026CFE 100%)'
      } else if (this.signName == '迟到打卡' || this.signName == '外勤打卡') {
        return 'linear-gradient(180deg, #FFB736 0%, #FFA400 100%)'
      } else if (this.signName == '无法打卡') {
        return 'linear-gradient(180deg, #B2B2B2 0%, #989898 100%)'
      }
    },
    showIconNormal() {
      return name => {
        let list = ['上班', '下班', '中午', '下午']
        if (list.includes(name)) {
          return true
        }
        return false
      }
    },

    showIconLate() {
      return name => {
        let list = ['迟到', '早退', '外勤-上班', '外勤-下班', '外勤-中午', '外勤-下午', '下午-迟到', '中午早退', '下午迟到', '缺卡']
        if (list.includes(name)) {
          return true
        }
        return false
      }
    },
  },
  methods: {
    async complete(GeolocationResult) {
      this.address = GeolocationResult.formattedAddress
      // this.address = GeolocationResult
      this.lng = GeolocationResult.position.lng
      this.lat = GeolocationResult.position.lat
      // 计算当前距离
      const res = await iApi.getAttendancePosition({ sxjhid: this.sxjhid, lng: this.lng, lat: this.lat })
      this.signStatus = res.data
      this.form.dkdd = this.address
      this.form.sxjhid = this.sxjhid
      this.form.lng = this.lng
      this.form.lat = this.lat
    },
    check(val) {
      if (val < 10) {
        return '0' + val
      } else {
        return val
      }
    },
    upload(e) {
      this.form.sqzp = e.file
    },
    displayTime() {
      var date = new Date()
      var hour = date.getHours()
      var minutes = date.getMinutes()
      var second = date.getSeconds()
      this.time = this.check(hour) + ':' + this.check(minutes) + ':' + this.check(second)
      // 获取当次打卡时间点是否处在时间范围内
      if (this.detail != {}&&this.detail.signList  && this.detail.signList.length > 0) {
        let signIndex = 0
        if (this.detail.qdcs == 2) {
          if (this.detail.dkd == 3) {
            signIndex = 1
          }
        } else {
          signIndex = this.detail.dkd
        }
        let timeStr = `${new Date().format('yyyy-MM-dd')} ${this.detail.signList[signIndex].signTime}:00`
        let dateTime = new Date(timeStr.replace(/\-/g, "/")).getTime()
        let nowTime = date.getTime()
        // this.$toast(`${nowTime}, ${dateTime}， ${timeStr}`)
        // 根据打卡点确定此时的状态
        if (this.detail.dkd == 0 || this.detail.dkd == 2) {
          // 上午上班打卡或下午上班打卡
          if (nowTime < dateTime + 60000) {
            // 未迟到
            // 是否在范围内
            if (this.signStatus.isdk) {
              this.signName = '上班打卡'
              this.signText = '您已在签到范围内'
              this.iconType = 1
              this.detail.dkd == 0 ? (this.signType = '01') : (this.signType = '08')
              this.stateType = 1
            } else if (!this.signStatus.isdk && this.signStatus.iswq) {
              this.signName = '外勤打卡'
              this.signText = '您还未到达签到范围'
              // this.backGround = 'linear-gradient(180deg, #FFB736 0%, #FFA400 100%);'
              this.iconType = 0
              this.detail.dkd == 0 ? (this.signType = '05') : (this.signType = '10')
              this.stateType = 0
            } else {
              this.signName = '无法打卡'
              this.signText = '您还未到达签到范围'
              // this.backGround = 'linear-gradient(180deg, #B2B2B2 0%, #989898 100%)'
              this.iconType = 0
            }
          } else {
            if (!this.signStatus.isdk && !this.signStatus.iswq) {
              this.signName = '无法打卡'
              this.signText = '您还未到达签到范围'
              // this.backGround = 'linear-gradient(180deg, #B2B2B2 0%, #989898 100%)'
              this.iconType = 0
            } else {
              // 迟到
              this.signName = '迟到打卡'
              this.signText = '您已超过打卡时间'
              // this.backGround = 'linear-gradient(180deg, #FFB736 0%, #FFA400 100%)'
              this.iconType = 0
              this.signType = '01'
              this.detail.dkd == 0 ? (this.signType = '03') : (this.signType = '12')
              this.stateType = 1
            }
          }
        } else if (this.detail.dkd == 1 || this.detail.dkd == 3) {
          // 中午下班打卡或下午下班打卡
          if (nowTime > dateTime - 60000) {
            if (this.signStatus.isdk) {
              this.signName = '下班打卡'
              this.signText = '您已在签到范围内'
              this.iconType = 1
              this.detail.dkd == 1 ? (this.signType = '07') : (this.signType = '02')
              this.stateType = 0
            } else if (!this.signStatus.isdk && this.signStatus.iswq) {
              this.signName = '外勤打卡'
              this.signText = '您还未到达签到范围'
              this.iconType = 0
              // this.backGround = 'linear-gradient(180deg, #FFB736 0%, #FFA400 100%);'
              this.detail.dkd == 1 ? (this.signType = '09') : (this.signType = '06')
              this.stateType = 0
            } else {
              this.signName = '无法打卡'
              this.signText = '您还未到达签到范围'
              // this.backGround = 'linear-gradient(180deg, #B2B2B2 0%, #989898 100%)'
              this.iconType = 0
            }
          } else {
            if (this.signStatus.isdk) {
              this.signName = '下班打卡'
              this.signText = '您已在签到范围内'
              this.iconType = 1
              this.detail.dkd == 1 ? (this.signType = '11') : (this.signType = '04')
              this.stateType = 0
            } else if (!this.signStatus.isdk && this.signStatus.iswq) {
              this.signName = '外勤打卡'
              this.signText = '您还未到达签到范围'
              // this.backGround = 'linear-gradient(180deg, #FFB736 0%, #FFA400 100%);'
              this.iconType = 0
              this.detail.dkd == 1 ? (this.signType = '11') : (this.signType = '04')
              this.stateType = 0
            } else {
              this.signName = '无法打卡'
              this.signText = '您还未到达签到范围'
              // this.backGround = 'linear-gradient(180deg, #B2B2B2 0%, #989898 100%)'
              this.iconType = 0
            }
          }
        }
        if (this.detail.signList[signIndex].signStatus == 1) {
          if (!this.signStatus.isdk && !this.signStatus.iswq) {
            this.signName = '无法打卡'
            this.signText = '您还未到达签到范围'
            // this.backGround = 'linear-gradient(180deg, #B2B2B2 0%, #989898 100%)'
            this.iconType = 0
          } else {
            this.form.type = 'gx'
            this.form.kqjlid = this.detail.signList[this.detail.dkd].kqjlid
            // this.backGround = 'linear-gradient(180deg, #0092FF 0%, #026CFE 100%)'
            this.signName = '更新打卡'
          }
        }
      }
    },
    async tabsChange(e) {
      if (e == 1 && this.pageData != {}) {
        const res = await iApi.getAttendanceList({ date: this.dqdkyf, sxjhid: this.sxjhid })
        this.pageData = res.data;
        // 获取当日的签到记录
        let today = new Date().format('yyyy-MM-dd')
        if(this.detail.isCanDk==-1){
          //计划已结束
          today = this.detail.jhjssj;
        }else if(this.detail.isCanDk==0){
          today = this.detail.jhkssj;
        }
        if(this.kqdkFlag){
          let index = this.pageData.dayList.findIndex(item => item.date === today)
          this.handleData(index, today)
        }
      }
    },
    routeLinkTotal() {
      this.$router.push({
        path: '/internship/statistics',
      })
    },

    sign() {
      if (this.signName != '无法打卡') {
        this.showDialog = true
      }
    },
    closeSignPopup() {
      this.showDialog = false
    },
    async saveSignData() {
      this.form.sxjhid = this.sxjhid
      if (this.signName == '无法打卡') {
        this.$toast('无法打卡')
        return
      }
      this.showDialog = false
      if (this.form.sqzp == '' && this.detail.qdsbxpz == 1) {
        this.$toast('请上传打卡照片')
        return
      }
      this.form.dklx = this.signType
      // console.log(this.form)
      const res = await iApi.setSignInfo(this.form)
      if (res.code == 0) {
        this.stateType = 2
      }
      this.$refs.state.open()
      this.getAttendanceInfo()
    },
    dateClick(e) {
      let index = this.pageData.dayList.findIndex(item => item.date === e.date)
      this.clickDate = e.date
      this.handleData(index, e.date)
    },
    handleData(index) {
      this.attendanceList = []
      if (index != -1) {
        // 缺卡数据补充，默认全填充
        for (let i = 0; i < parseInt(this.pageData.dayList[index].dkcs); i++) {
          // 今天并且存在打卡点，打卡点之前的数据显示缺卡
          if (this.pageData.dayList[index].thedayDkd != '') {
            if (i < parseInt(this.pageData.dayList[index].thedayDkd)) {
              this.attendanceList.push({
                address: '',
                dkd: '',
                fileBase64: '',
                img: '',
                kqjlid: '',
                name: '缺卡',
                remarks: '',
                status: '',
                time: '',
              })
            }
          } else {
            this.attendanceList.push({
              address: '',
              dkd: '',
              fileBase64: '',
              img: '',
              kqjlid: '',
              name: '缺卡',
              remarks: '',
              status: '',
              time: '',
            })
          }
        }
        // 替换当日的打卡数据进入
        this.pageData.dayList[index].signList.forEach((item, idx) => {
          if (this.pageData.dayList[index].dkcs == 2) {
            if (item.dkd == 0) {
              this.attendanceList[0] = item
            } else if (item.dkd == 3) {
              this.attendanceList[1] = item
            }
          } else {
            this.attendanceList[item.dkd] = item
          }
        })
        this.attendanceList.forEach((item,idx)=>{
          item.dklx = idx;
        })
      }
    },
    async getAttendanceInfo() {
      const parm={
        sxjhid:this.sxjhid
      };
      const res = await iApi.getAttendanceInfo(parm)
      this.detail = res.data;
      this.kqdkFlag = res.data.isCanDk=='1';
      this.form.sxgwid = this.detail.sxgwid;
      this.dknyList= res.data.kqnyList;
      if(res.data.isCanDk==-1){
        this.dkny = this.dknyList[this.dknyList.length-1].text;
        this.dqdkyf = this.dknyList[this.dknyList.length-1].value;
        this.yearToSee = this.dknyList[this.dknyList.length-1].year;
        this.monthToSee = this.dknyList[this.dknyList.length-1].month;
      }else if(res.data.isCanDk==0){
        this.dkny = this.dknyList[0].text;
        this.dqdkyf = this.dknyList[0].value;
        this.yearToSee = this.dknyList[0].year;
        this.monthToSee = this.dknyList[0].month;
      }
      this.dkbyIndex = this.dknyList.findIndex(item => item.text === this.dkny);
      if (this.timer != null) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        this.displayTime()
      }, 1000)
    },
    showDatePicker(){
      this.showPickerDate= true;
    },
    chooseDate(e){
      this.dkny = e.text;
      this.dqdkyf = e.value;
      this.showPickerDate= false;
      this.reloadDkDetal(e.year,e.month);
    },
    async reloadDkDetal(dkyear,dkmonth){
      const res = await iApi.getAttendanceList({ date: this.dqdkyf, sxjhid: this.sxjhid })
        this.pageData = res.data;
        console.log(this.pageData)
        // 获取当日的签到记录
        let today = dkyear+"-"+(dkmonth>=10?dkmonth:("0"+dkmonth));
        let index = this.pageData.dayList.findIndex(item => item.date === today);
        this.yerToSee = dkyear,
        this.monthToSee = dkmonth;
        this.dqdkyf = dkyear+"-"+(dkmonth>=10?dkmonth:("0"+dkmonth))
        this.handleData(index, today)
    }

  },
  async created() {
    let nowdate = new Date();
    this.dkny = nowdate.getFullYear()+"年"+(nowdate.getMonth()+1)+"月";
    this.yerToSee = nowdate.getFullYear();
    this.monthToSee = nowdate.getMonth()+1;
    this.dqdkyf = nowdate.getFullYear()+"-"+((nowdate.getMonth()+1)>=10?(nowdate.getMonth()+1):('0'+(nowdate.getMonth()+1)));
    this.getAttendanceInfo()
    // 浏览器无法调试暂时写死
    // const res = await iApi.getAttendancePosition({ sxjhid: this.sxjhid, lng: this.lng, lat: this.lat })
    // this.signStatus = res.data
    // this.form.sxjhid = this.sxjhid
    // this.form.lng = this.lng
    // this.form.lat = this.lat
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
  padding-bottom: 50px;
}
.van-tabs__line {
  background-color: #0088f8 !important;
  width: 25px;
}
.van-tab--active {
  color: #333333 !important;
  font-weight: 600 !important;
}
.top-card {
  margin: 15px auto 10px;
  width: 315px; // 宽度会被padding撑开
  min-height: 117px;
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;
  .title {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
  }
  .tip {
    margin-top: 4px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    // line-height: 14px;
    color: #999999;
  }
  .time-box {
    margin-top: 15px;
    display: grid;
    // justify-content: space-between;
    // flex-wrap: wrap;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    .item {
      // flex: 1;
      height: 50px;
      background: #ededed;
      border-radius: 8px;
      padding-top: 6px;
      // margin-right: 10px;
      // margin-bottom: 10px;
      .time {
        margin-left: 12px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
      }
      .status {
        margin-left: 12px;
        margin-top: 4px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        display: flex;
        align-items: center;
        img {
          width: 12px;
          height: 12px;
          margin-right: 3px;
        }
      }
    }
  }
}
.option-card {
  margin: 0 auto;
  width: 315px;
  padding: 15px;
  height: 478px;
  background: #ffffff;
  border-radius: 8px;
  position: relative;
  .address-box {
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .address {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
      }
      .option {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #0189f9;
      }
    }
    .map {
      overflow: hidden;
      margin: 12px auto 0;
      width: 315px;
      height: 90px;
      border-radius: 6px;
    }
  }
  .sign-box {
    .item {
      width: 136px;
      height: 136px;
      // background-image: linear-gradient(180deg, #0092ff 0%, #026cfe 100%);
      box-shadow: 0 8px 8px 0 rgba(1, 137, 249, 0.25);
      border-radius: 50%;
      margin: 40px auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .name {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
        text-align: center;
      }
      .now {
        opacity: 0.5;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
      }
    }
    .status {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 18px;
        height: 18px;
      }
      div {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        margin-left: 5px;
      }
    }
  }
}
.popup {
  position: relative;
  .header {
    height: 38px;
    position: relative;
    padding-top: 16px;
    border-bottom: 1px solid #e5e5e5;
    img {
      width: 13px;
      height: 13px;
      margin-left: 15px;
    }
    .title {
      position: absolute;
      transform: translate(-50%, -50%);
      left: 50%;
      top: 50%;
      text-align: center;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }
  }
  .upload {
    display: flex;
    justify-content: space-between;
    padding: 13px 15px;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;
    .add {
      width: 50px;
      height: 50px;
      border: 1px solid #e5e5e5;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 22px;
        height: 18px;
      }
    }
  }
  .remark {
    padding: 13px 15px;
  }
  .sure-button {
    position: fixed;
    bottom: 20px;
    left: 15px;
    right: 15px;
    width: 345px;
    height: 50px;
    background: #0189f9;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    margin: 0 auto;
    line-height: 50px;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
  }
  .sure-button:active {
    background-color: rgba(0, 0, 0, 0.1);
    opacity: 0.7;
  }
}
.total-box {
  width: 345px;
  height: 180px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto;
  .title {
    display: flex;
    justify-content: space-between;
    padding: 16px 20px 0 20px;
    .left {
      font-weight: bold;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      line-height: 22px;
      color: #333333;
    }
  }
  .content {
    margin-top: 16px;
    display: flex;
    .item-box {
      width: 33.33%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .top {
        font-weight: bold;
        font-family: PingFangSC-Semibold;
        font-size: 26px;
        line-height: 37px;
        color: #333333;
      }
      .bottom {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
      }
    }
  }
}
.calendar {
  width: 345px;
  // height: 566px;
  padding-bottom: 25px;
  background: #ffffff;
  border-radius: 8px;
  margin: 0 auto;
  .title {
    padding-top: 18px;
    margin-left: 18px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    p {
      font-size: 14px;
      color: #999999;
    }
  }
}
.details {
  display: flex;
  padding: 0 15px;
  margin-top: 9px;
  .left-box {
    line-height: 22px;
    .circle {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #999999;
      margin-top: 5px;
    }
    .line {
      width: 1px;
      height: 100%;
      border-left: 1px solid #cccccc;
      background: #cccccc;
      margin-left: 4px;
      margin-top: 3px;
      margin-bottom: 6px;
    }
  }
  .right-box {
    margin-left: 18px;
    .right-title {
      display: flex;
      align-items: center;
      .text {
        font-weight: bold;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        line-height: 22px;
        color: #333333;
        max-width: 225px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .status {
        min-width: 36px;
        margin-left: 12px;
        height: 18px;
        border-radius: 9px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        letter-spacing: 0;
        text-align: center;
        line-height: 18px;
        padding: 0 2px;
        background: #fe923f;
        color: #ffffff;
      }
    }

    .centent {
      margin-top: 8px;
      p {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        line-height: 18px;
        color: #999999;
      }
    }
  }
}
.apply-button {
  width: 82px;
  height: 28px;
  border: 1px solid #0189f9;
  border-radius: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #0189f9;
  line-height: 28px;
  text-align: center;
  margin-top: 6px;
}
.sign-img {
  display: block;
  width: 40px;
  height: 40px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  margin-top: 6px;
}
.empty-sign {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
  img {
    width: 76px;
    height: 76px;
    margin-bottom: 24px;
  }
  div {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    text-align: center;
    line-height: 18px;
  }
}
.upload {
  .van-uploader__preview-image {
    width: 50px !important;
    height: 50px !important;
    border-radius: 6px;
  }
}
.van-cell{
  padding: 0;
}

/deep/ .van-cell.van-field .van-cell__title.van-field__label>span{
    color: #333333 !important;
}

.sxoverdiv{
  padding-top: 20px;
  text-align: center;
  p{
    font-weight: bold;
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    line-height: 22px;
    color: #333333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/attendance.vue